import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngxs/store';
import { ISmallBrickComponent } from 'src/app/components/dashboard/brick-settings/brick-specific-type-settings/ISpecificBrickSettingsComponent';
import { CallControlBrickBaseComponent } from './call-control-brick.base.component';

@Component({
   selector: 'samweb-call-control-brick-small',
   templateUrl: './call-control-brick.small.component.html',
   styleUrls: ['./call-control-brick.small.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallControlBrickSmallComponent extends CallControlBrickBaseComponent implements ISmallBrickComponent {
   constructor(store: Store) {
      super(store);
   }
}
